export default __webpack_public_path__ + "192061adfadb0c572ddc2bb57aea6a52.png";